import { AutogenModelEdiProcessSetting, AutogenRowEdiProcessSetting } from "./autogen/AutogenModelEdiProcessSetting";

export class ModelEdiProcessSetting extends AutogenModelEdiProcessSetting<RowEdiProcessSetting> {
	constructor() {
		super(RowEdiProcessSetting);
	}
}

export class RowEdiProcessSetting extends AutogenRowEdiProcessSetting {
}